export default "__VITE_PUBLIC_ASSET__9ff807ab__"